<template>
    <NuxtLayout name="main">
        <div :class="css.container">
            <div class="max-lg:pt-[20px] max-lg:pb-[22px]" :class="css.header" :style="`background-image: url(${options.cover});`">
                <div class="font-bold text-center" :class="css.name">Rare Disease Data Center</div>
                <div :class="css.videos">
                    <video class="w-[100%] h-[100%] object-contain bg-[#000000]" controls muted :src="options.video"></video>
                </div>
            </div>

            <div class="container pt-[96px] max-xl:pt-[64px] max-lg:pt-[48px]">
                <div class="flex items-center justify-between">
                    <!-- * 筛选项 -->
                    <div class="flex items-center" :class="css.menus">
                        <div :class="[css.menu, mode == 'video' && css.active]" @click="(mode = 'video'), methods.init()">
                            {{ $t("VideoTutorial2") }}
                        </div>
                        <div :class="css.division"></div>
                        <div :class="[css.menu, mode == 'graphic' && css.active]" @click="(mode = 'graphic'), methods.init()">
                            {{ $t("GraphicsTutorial") }}
                        </div>
                    </div>

                    <!-- * 检索框 -->
                    <div class="w-[496px]">
                        <default-search v-model="keyword" size="middle" width="100%" :placeholder="$t('SearchPlaceholder')" />
                    </div>
                </div>

                <!-- * 无数据 -->
                <div
                    class="flex items-center justify-center mt-[48px] min-h-[160px] bg-uicolor5 text-emphas text-[16px] font-bold"
                    v-show="!data.length">
                    {{ $t("NoData") }}
                </div>

                <!-- * 数据列表 -->
                <div class="flex flex-wrap" v-show="data.length">
                    <project-route
                        v-for="value in data"
                        :to="value.href"
                        :title="value.name"
                        class="block mt-[40px] w-[calc((100%-(32px*3))/4)] [&:not(:nth-child(4n+1))]:ml-[32px] group max-xl:w-[calc((100%-(24px*3))/4)] max-xl:[&:not(:nth-child(4n+1))]:ml-[24px] max-xl:mt-[32px]">
                        <div class="relative w-[100%] h-[200px] rounded-[4px] max-xl:h-[176px]">
                            <img class="w-full h-full object-cover" :src="value.cover" />
                            <img
                                v-if="mode == 'video'"
                                class="absolute top-0 right-0 bottom-0 left-0 m-auto w-[72px] h-[72px] max-lg:w-[52px] max-lg:h-[52px]"
                                src="https://rdgta.cdn.cyagen.com/rddc/images/play.webp"
                                alt="" />
                        </div>
                        <div class="mt-[16px] mb-[8px] line-clamp-2 text-emphas font-bold group-hover:text-main max-lg:leading-[22px]">
                            {{ value.name }}
                        </div>
                        <div class="text-default">{{ value.date }}</div>
                    </project-route>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 公共组件
import { DefaultSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组合函数
const {
    refs: { mode, keyword },
    methods,
    options,
    computeds: { data },
} = useComposable();

//* 页面数据初始化
methods.init();
</script>
